import React from 'react'
import TeamRegistrationHomeNavigation from './TeamRegistrationHomeNavigation'
import TeamRegistration from '../../schedule/TeamRegistration'
import RegistrationPageGuard from '../../schedule/RegistrationPageGuard'

const TeamRegistrationHome = () => {
	return (
		<RegistrationPageGuard navigation={<TeamRegistrationHomeNavigation />}>
			<TeamRegistration />
		</RegistrationPageGuard>
	)
}

export default TeamRegistrationHome
